export const wrapperIdentifier = 'internationalization';
